/* STADTHOLZ Edition: Filter nach Art (Unikat / Serie / Sonderholz). Ohne JS bleiben alle Stücke sichtbar. */
(function () {
  function init(root) {
    if (!root || root.hasAttribute('data-sz-ed-ready')) return;
    root.setAttribute('data-sz-ed-ready', '');

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-sz-ed-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sz-ed-art]'));
    var empty = root.querySelector('[data-sz-ed-empty]');
    var result = root.querySelector('[data-sz-ed-result]');
    var archiv = parseInt(root.getAttribute('data-archiv') || '0', 10);
    if (!buttons.length) return;

    function apply(filter) {
      var sichtbar = 0;
      cards.forEach(function (card) {
        var passt = filter === 'alle' || card.getAttribute('data-sz-ed-art') === filter;
        card.hidden = !passt;
        if (passt) sichtbar += 1;
      });
      buttons.forEach(function (btn) {
        btn.setAttribute('aria-pressed', btn.getAttribute('data-sz-ed-filter') === filter ? 'true' : 'false');
      });
      if (empty) empty.hidden = sichtbar > 0;
      if (result) result.textContent = sichtbar + ' verfügbar · ' + archiv + ' im Archiv';
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        apply(btn.getAttribute('data-sz-ed-filter'));
      });
    });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sz-edition]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
